import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Stack, Tab } from '@mui/material';
import React, { useState } from 'react';
import InitialStateTable from './InitialStateTable';
import HConfigTab from './supportTabs/HConfigTab';
import HErrorTab from './supportTabs/HErrorTab';
import HGeneralTab from './supportTabs/HGeneralTab';
import HNotesTab from './supportTabs/HNotesTab';
import HProvisioningTab from './supportTabs/HProvisioningTab';
const headers = ['General', 'Config', 'Errors', 'Provisioning', 'Notes'];
const HistoryTab = (props) => {
    const { device, deviceHistory } = props;
    const [tab, setTab] = useState(headers[0]);
    return (_jsxs(Stack, { gap: 1, children: [_jsx(InitialStateTable, { history: deviceHistory }), _jsxs(TabContext, { value: tab, children: [_jsx(TabList, { onChange: (_, newTab) => setTab(newTab), children: headers.map((t) => (_jsx(Tab, { label: t, value: t, sx: { textTransform: 'none' } }, t))) }), _jsx(TabPanel, { value: "General", sx: { padding: 0, paddingBlockStart: 0.5 }, children: _jsx(HGeneralTab, { deviceHistory: deviceHistory }) }), _jsx(TabPanel, { value: "Config", sx: { padding: 0, paddingBlockStart: 0.5 }, children: _jsx(HConfigTab, { deviceHistory: deviceHistory }) }), _jsx(TabPanel, { value: "Errors", sx: { padding: 0, paddingBlockStart: 0.5 }, children: _jsx(HErrorTab, { deviceHistory: deviceHistory }) }), _jsx(TabPanel, { value: "Provisioning", sx: { padding: 0, paddingBlockStart: 0.5 }, children: _jsx(HProvisioningTab, { device: device }) }), _jsx(TabPanel, { value: "Notes", sx: { padding: 0, paddingBlockStart: 1 }, children: _jsx(HNotesTab, { device: device }) })] })] }));
};
// Presents a filterable list of actions/ changes in a device history - what, when, who?
// # Set up in application or changed? (Provisioned)
// # Set up on network or changed? (Provisioned)
// # Firmware upgraded
// # Config and calibration changes by user?
// # Automated setting or other changes arising from downlink?
// # State changes?
// # Location changes?
// # Customer association and changes?
// # Entity association and changes?
// # Faults and resolution
// Maintains history after a device is decommissioned/ removed from active use
export default HistoryTab;
